export const ERROR_PREFIX = 'NP_ERRORS';
